export default (function () {
    const navButton = document.getElementsByClassName('nav-control')[0],
        navDrawer = document.getElementsByClassName('nav-drawer')[0];

    navButton.addEventListener('click', _ => {
        navDrawer.classList.add('nav-drawer--active');
    });
})();